import { toBase64 } from '../../common/Utils/base64';
import { useApi } from './apiService';

export const useTenantScriptService = () => {
  const api = useApi();

  // Upload new tenant script
  const uploadTenantScript = async (tenantId: string, scriptName: string, scriptDescription: string, files: File[]) => {
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('file', file);
      });
      formData.append('ScriptName', scriptName);
      formData.append('Description', toBase64(scriptDescription));

      const response = await api.post(`tenantservice/TenantScript/${tenantId}/add-tenant-script`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return response.data;
    } catch (error) {
      console.error('Error uploading tenant script:', error);
      throw error;
    }
  };

  // Update existing tenant script
  const updateTenantScript = async (tenantId: string, scriptId: string, scriptName: string, scriptDescription: string, files: File[]) => {
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('file', file);
      });
      formData.append('ScriptName', scriptName);
      formData.append('Description', toBase64(scriptDescription));

      const response = await api.put(`tenantservice/TenantScript/${tenantId}/update-tenant-script/${scriptId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return response.data;
    } catch (error) {
      console.error('Error updating tenant script:', error);
      throw error;
    }
  };

  return { uploadTenantScript, updateTenantScript };
};
